import { CallsPlatformModel } from './calls-platform.model';
import { ConversationIntelligencePlatformModel } from './conversation-intelligence-platform.model';
import { FormsPlatformModel } from './forms-platform.model';
import { LeadCenterPlatformModel } from './lead-center-platform.model';
import { ConvertAssistPlatformModel } from './convert-assist-platform.model';
import { PlatformModel } from './platform.model';
import { VoiceAssistPlatformModel } from './voice-assist-platform.model';

export function createPlatformModel(
  plan: any,
  platform: string
): PlatformModel {
  let model = null;
  switch (platform) {
    case 'calls':
      model = new CallsPlatformModel(plan);
      break;
    case 'forms':
      model = new FormsPlatformModel(plan);
      break;
    case 'conversation_intelligence':
      model = new ConversationIntelligencePlatformModel(plan);
      break;
    case 'lead_center':
      model = new LeadCenterPlatformModel(plan);
      break;
    case 'convert_assist':
      model = new ConvertAssistPlatformModel(plan);
      break;
    case 'voice_assist':
      model = new VoiceAssistPlatformModel(plan);
      break;
  }
  return model;
}
